import React, { Component } from 'react';
import { firebase } from '../firebase';
import Landing from './pages/Landing';
import Imprint from './pages/Imprint';
import About from './pages/About';
import Nav from './Nav';
import Footer from './Footer';

import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as routes from '../constants/routes';

class App extends Component {
  render() {
    return (
      <Router>
        <div className='d-flex flex-column' style={{minHeight: '100vh'}}>
          <Nav />
          <Route
            exact path={routes.LANDING}
            component={() => <Landing />}
          />
          <Route
            exact path={routes.IMPRINT}
            component={() => <Imprint />}
          />
          <Route
            exact path={routes.ABOUT}
            component={() => <About />}
          />
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js